import { appConfig, type AppEnvironment } from '@/config/environment'
import styles from './EnvironmentLabel.module.scss'

// Production is the real app, so it carries no badge; only the environments
// people test in are marked, matching the app icons.
const labels: Readonly<Partial<Record<AppEnvironment, string>>> = {
  local: 'local',
  development: 'dev',
}

export function EnvironmentLabel({
  environment = appConfig.appEnvironment,
}: {
  environment?: AppEnvironment
}) {
  const label = labels[environment]
  if (!label) return null
  return <span className={styles.label} role="status" aria-label={`${label} environment`}>{label}</span>
}
